import React from "react";
import { createComponent, EventName } from "@lit/react";
import { BeamNonprofitSelectEvent } from "../../utils/events";
import { BeamSubscriberSelectNonprofit as _BeamSubscriberSelectNonprofit } from "./index";

export const BeamSubscriberSelectNonprofit = createComponent({
  tagName: _BeamSubscriberSelectNonprofit.tagName,
  elementClass: _BeamSubscriberSelectNonprofit,
  react: React,
  events: {
    onNonprofitSelect: BeamNonprofitSelectEvent.eventName as EventName<BeamNonprofitSelectEvent>,
  },
});

export default BeamSubscriberSelectNonprofit;
